import {
  MainAccountsQuery,
  MainAccountsQuery_billing_mainAccounts,
} from './../shared/queries/MainAccountsQuery/__generated__/MainAccountsQuery';
import * as qs from 'qs';
import * as dataLayer from 'shared/utils/gtmDataLayer';
import { PendingDeposit } from 'types/common';
import { Services } from 'init/services';
import { getContext, call, takeEvery, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { SagaContext } from 'shared/types/common';
import { mainAccountQuery } from 'shared/queries/MainAccountsQuery/builder';
import { isEmpty } from 'lodash-es';
import { SHOW_DEPOSIT_MODAL } from '../shared/actions/app';

const isCloseEnough = (a: number, b: number, c: number) => Math.abs(a - b) < c;

const isFirstDeposit = (
  accounts: MainAccountsQuery_billing_mainAccounts[],
  pendingDeposit: PendingDeposit
) => {
  if (isEmpty(accounts) || isEmpty(pendingDeposit) || accounts.length > 1) {
    return false;
  }

  const [{ balance }] = accounts;
  const { amount } = pendingDeposit;

  if (balance.currency === amount.currency && isCloseEnough(balance.value, amount.value, 0.5)) {
    return true;
  }
  return false;
};

function getPendingDeposit(): PendingDeposit | undefined {
  try {
    return JSON.parse(window.localStorage.getItem('pending-deposit') || '');
  } catch (e) {}

  return;
}

function getDepositId() {
  const { depositId } = qs.parse(window.location.search.substr(1));
  return depositId;
}

export default function* saga() {
  if (typeof window === 'undefined') {
    return;
  }

  yield takeEvery(SHOW_DEPOSIT_MODAL, function* () {
    if (window.location.pathname.match(/\/deposit/)) {
      const base = window.location.pathname.replace(/\/deposit/g, '');
      yield put(push(base));
      yield new Promise((resolve) => setTimeout(resolve, 0));
      yield put(push(`${base}/deposit`.replace(/\/{2,}/g, '/')));
      return;
    }
    const pathname = `${window.location.pathname}/deposit`.replace(/\/{2,}/g, '/');
    yield put(push(pathname));
  });

  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  try {
    const { data }: { data: MainAccountsQuery } = yield call(
      apolloClient.query,
      mainAccountQuery()
    );

    const depositId = getDepositId();
    const pendingDeposit = getPendingDeposit();

    if (pendingDeposit && depositId && pendingDeposit.requestId === depositId) {
      dataLayer.push({
        eventCategory: 'form',
        eventAction: isFirstDeposit(data.billing.mainAccounts, pendingDeposit)
          ? 'deposit-first'
          : 'deposit',
      });

      const { amount, orderSubmitTo } = pendingDeposit;
      if (orderSubmitTo) {
        dataLayer.push({
          eventCategory: 'form',
          eventAction: 'orderSubmit',
          eventLabel: orderSubmitTo,
          eventValue: `${amount.value}`,
        });
      }

      window.localStorage.removeItem('pending-deposit');
    }
  } catch (e) {
    console.error(e);
    window.localStorage.removeItem('pending-deposit');
  }
}
